import { jsxs as r, Fragment as l, jsx as C } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ r(l, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M6 1C4.34315 1 3 2.34315 3 4V21C3 22.1046 3.89543 23 5 23H18C19.6569 23 21 21.6569 21 20V9.5H16.5C14.2909 9.5 12.5 7.70914 12.5 5.5V1H6ZM9.36569 12.2343C9.05327 11.9219 8.54673 11.9219 8.23431 12.2343C7.9219 12.5467 7.9219 13.0533 8.23431 13.3657L10.8686 16L8.23431 18.6344C7.9219 18.9468 7.9219 19.4533 8.23431 19.7657C8.54673 20.0781 9.05327 20.0781 9.36569 19.7657L12 17.1314L14.6344 19.7657C14.9468 20.0781 15.4533 20.0781 15.7657 19.7657C16.0781 19.4533 16.0781 18.9468 15.7657 18.6344L13.1314 16L15.7657 13.3657C16.0781 13.0533 16.0781 12.5467 15.7657 12.2343C15.4533 11.9219 14.9468 11.9219 14.6344 12.2343L12 14.8686L9.36569 12.2343Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ),
  /* @__PURE__ */ C("path", { d: "M16.5 7.5C15.3954 7.5 14.5 6.60457 14.5 5.5V1.01758C17.9675 1.2623 20.7377 4.03251 20.9824 7.5H16.5Z", fill: "currentColor" })
] });
export {
  o as default
};
